// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1EObo","button-primary":"Button_button-primary__7UAFR","button-secondary":"Button_button-secondary__u9hTU"};